<template>
  <div
    class="container flex-col flex-align-start mw-400 pad-top-30 pad-bottom-30"
  >
    <h2 class="fs-large pad-top-20p pad-bottom-20">
      <b> Locale<span class="fc-primary">.ai</span> </b>
    </h2>
    <h3 class="item-header">Sign in to your account</h3>
    <form class="mar-top-20" @submit.prevent="authenticate">
      <div class="flex-col">
        <label class="mar-bottom-5">Email Address</label>
        <input v-model="email" type="email" placeholder="hello@example.com" />
      </div>
      <label v-if="isEmailError" class="fc-error">{{ errorMessage }}</label>
      <div class="flex-col mar-top-10">
        <label class="mar-bottom-5">Password</label>
        <input v-model="password" placeholder="Password" type="password" />
      </div>
      <a href="#" class="help-link">Forgot your password?</a>
      <div class="flex-row-align-center">
        <!-- sign in with google button -->
        <!-- <GoogleSignIn @success="gAuthSuccess" /> -->

        <!-- mind the gap :) -->
        <div class="flex-expand"></div>
        <Spinner v-if="isRequestInProgress" />
        <input
          type="submit"
          v-if="!isRequestInProgress"
          class="round-button-primary glow-shadow"
          @click="authenticate()"
          value="Sign In"
        />
      </div>
    </form>
    <!-- <p>
      New to Locale.ai? Let's
      <router-link to="/auth/register" class="fc-primary">create a new account.</router-link>
    </p>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validateEmail } from "@/lib/validations";
import GoogleSignIn from "@/components/auth/views/GoogleSignIn";

export default {
  components: {
    GoogleSignIn,
  },
  props: {
    nextUrl: String,
  },
  data: () => ({
    isPasswordVisible: false,
    email: "",
    password: "",
    isRequestInProgress: false,
    errorMessage: "",
    isEmailError: false,
  }),
  methods: {
    ...mapActions("User", ["signIn", "signInWithGoogle"]),
    performSignIn($event) {
      $event.preventDefault();
      this.authenticate();
    },
    gAuthSuccess: function(token) {
      this.isRequestInProgress = true;
      this.signInWithGoogle(token)
        .then(response => {
          if (response.status === 200) {
            // check if the auth screen is opened from another page
            if (this.$route.query.nextUrl) {
              this.$router.push(this.$route.query.nextUrl);
            } else {
              this.$router.push("/");
            }
          } else {
            throw new Error("Internal Server Error");
          }
        })
        .catch(error => {
          this.isRequestInProgress = false;
        });
    },
    authenticate() {
      if (!this.email || !validateEmail(this.email)) {
        this.errorMessage = "Invalid email";
        this.isEmailError = true;
        return;
      }

      if (validateEmail(this.email) && this.password.length > 6) {
        this.isRequestInProgress = true;
        this.signIn({ email: this.email, password: this.password })
          .then(response => {
            this.isRequestInProgress = false;
            if (response.status === 200 && response.data.data.token) {
              if (this.$route.query.nextUrl) {
                // set fullStory.com user information
                const { name, email } = response.data.data;
                if (window.FS) {
                  window.FS.setUserVars({
                    displayName: name,
                    email,
                  });
                }
                this.$router.push(this.$route.query.nextUrl);
              } else {
                this.$router.push("/");
              }
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.errorMessage = error.response.data.detail;
              this.isEmailError = true;
            }
            this.isRequestInProgress = false;
          });
      }
    },
    toggleVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      if (this.isPasswordVisible) {
        this.$refs.passwordInput.setAttribute("type", "text");
      } else {
        this.$refs.passwordInput.setAttribute("type", "password");
      }
    },
  },
  computed: {},
  watch: {
    email(value) {
      if (this.isEmailError) {
        if (validateEmail(value)) {
          this.isEmailError = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.mw-400 {
  max-width: 400px;
}
</style>
